import React from 'react';
import Chip from '@material-ui/core/Chip';
import PPMobileCardView from '../../../components/PPMobileCardView';

// One row per stage the batch has been in: shed name, its date range and an Active pill,
// on the same stage colours as the desktop columns
const stageValue = (shedName, dateRange, isActive, background) => (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
        <span className="pp-card-value-bold">{shedName}</span>
        <span style={{ background, borderRadius: 20, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>{dateRange}</span>
        {isActive && <Chip className="pp-pill" label="Active" style={{ backgroundColor: '#4caf50', color: 'white' }} />}
    </div>
);

const Mobile = ({ data, onEdit }) => {
    const rows = [
        ...(data.chickName ? [{ label: 'Chick', value: stageValue(data.chickName, data.ChickDateRange, data.chickActive, '#E8F7F4'), fullWidth: true }] : []),
        ...(data.growerName ? [{ label: 'Grower', value: stageValue(data.growerName, data.GrowerDateRange, data.growerActive, '#FFF4C9'), fullWidth: true }] : []),
        ...(data.layerName ? [{ label: 'Layer', value: stageValue(data.layerName, data.LayerDateRange, data.layerActive, '#F0E8FE'), fullWidth: true }] : []),
    ];

    return (
        <PPMobileCardView
            title={data.batchName}
            rows={rows}
            menuItems={[{ label: 'Edit', onClick: onEdit }]}
        />
    );
};

export default Mobile;
